import { useQuery } from "@tanstack/react-query";
import React from "react";
import { MdOutlineCheck } from "react-icons/md";
import { InitialDataQCHeaderStatus } from "../../../../api/apiCallManager";
import { IoCloseOutline } from "react-icons/io5";
import useHeaderDataStatus from "../../../../components/hooks/useHeaderDataStatus";
import WrapperLoader from "../../../../components/spinner/WrapperLoader";

function InitialDataQc({ scriptPresentData, scriptPresentDataIsLoading }) {
  const isInitialDataQcFound =
    scriptPresentData?.files?.["initial_data_qc.py"]?.file_name;
  return (
    <div
      title={!isInitialDataQcFound && "Script is missing"}
      className={
        scriptPresentDataIsLoading
          ? "text-gray-400"
          : !isInitialDataQcFound && "text-red-400"
      }
    >
      {/* {JSON.stringify(scriptPresentData)} */}
      Initial Data QC
      <WrapperLoader isLoading={scriptPresentDataIsLoading}></WrapperLoader>
      {/* <div className="flex justify-center ">
        <WrapperLoader isLoading={scriptPresentDataIsLoading}>
          {isInitialDataQcFound ? (
            <MdOutlineCheck color="green" size={16} />
          ) : (
            <IoCloseOutline color="red" size={16} />
          )}
        </WrapperLoader>
      </div> */}
    </div>
  );
}

export default InitialDataQc;
